<ng-container>
  <!--  TODO uncomment this line when implementing mobile only -->
  <!--  <ng-container *ngIf="isMobileDevice else notMobileDevice">-->

<!--  <app-header></app-header>-->

  <div style="width: 100%;">
    <div style="display: flex; height: 100%">
      <img style="position: absolute; z-index: 0; height: 210px; width: 100%"
           src="../../../../assets/images/header/Header.png" alt="header">

      <div
        style="display: flex; justify-content: center; align-items: center; z-index: 1; flex-direction: column; width: 100%; height: 100%;">
        <img src="../../../../assets/images/logo_icon/logo_icon.png" alt="Gabadoo Logo" margin = "200px">
        <p style="   margin-top: 11px; font-weight: bold; color: #FFFFFF; font-size: 22px;">My Gabadoos</p>

        <mat-tab-group mat-align-tabs="center" [selectedIndex]="1">
          <mat-tab label="Drafts">
            <app-pending-reviews></app-pending-reviews>
          </mat-tab>
          <mat-tab label="Active">
              <app-active-reviews></app-active-reviews>
          </mat-tab>
          <mat-tab label="Completed">
            <app-completed-reviews></app-completed-reviews>
          </mat-tab>
        </mat-tab-group>
      </div>
    </div>
  </div>
 <app-navbar></app-navbar>
</ng-container>

<!--&lt;!&ndash; not mobile device &ndash;&gt;-->
<ng-template #notMobileDevice>
  <div class="desktop-container">
    <div class="py-4 text-center header-image">
      <img class="logo-img" src="../../../../assets/images/logo/Logo.png" alt="Gabadoo Logo">
    </div>

    <div class="desktop-text-container">
      <h1 style="text-align: center;">You cannot access this page on a desktop</h1>
      <p>Please re-open on a mobile device</p>
    </div>
  </div>
</ng-template>
